import { Decorative } from "@faire/design-tokens";
import { ContactUsButton } from "@faire/help-center-self-serve/components/ContactUsButton";
import { SelfServeSource } from "@faire/help-center-self-serve/consts";
import { useAIChatbotAccess } from "@faire/help-center-self-serve/hooks/useAIChatbotAccess";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const NeedMoreHelpBanner: React.FC = () => {
  const { isMobile } = useViewport();
  const { hasAIChatbotAccess } = useAIChatbotAccess();

  return (
    <Wrapper>
      <ColorWrapper>
        <ContentWrapper>
          <Typography
            variant={isMobile ? "displaySSerifRegular" : "displayMSerifRegular"}
          >
            <StrictLocalMsg
              defaultMessage="Need more help?"
              description={{
                text: "Title for need more help",
                img: "https://cdn.faire.com/fastly/32017940357dace8aa27c3cb6f98822584f8bdf7470a0d550691d7d1d443e2ee.png",
              }}
            />
          </Typography>
          <Spacer height="2x" />
          {hasAIChatbotAccess ? (
            <Typography variant="paragraphSansRegular">
              <StrictLocalMsg
                defaultMessage="Start a chat to find answers quickly or connect with our support team."
                description={{
                  text: "Message about using the chatbot for help.",
                }}
              />
            </Typography>
          ) : (
            <Typography variant="paragraphSansRegular">
              <StrictLocalMsg
                defaultMessage="Share more about your issue, and get in touch with our support team."
                description={{
                  text: "Message about what to do if more help is needed.",
                  img: "https://cdn.faire.com/fastly/3e55217625248fa1388f8246c70c4bd380b57a17dc3847db3d3312f1874c5561.png",
                }}
              />
            </Typography>
          )}
          <Spacer height="3x" />
          <StyledContactUsButton
            source={SelfServeSource.CONTACT_US_FOOTER_BANNER}
          />
        </ContentWrapper>
      </ColorWrapper>
    </Wrapper>
  );
};

const Wrapper = styled(Column).attrs({ justify: "center", align: "center" })`
  margin-top: ${getSpacing("2x")};
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("7x")};
  }
`;

const ColorWrapper = styled(Row)`
  background-color: ${Decorative.tint.orange};
  width: 100%;
  max-width: 1500px;
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing("7x")};
    justify-content: center;
  }
  ${responsiveMediaQueries.mobile} {
    padding: ${getSpacing("6x", "3x")};
    justify-center: flex-start;
  }
`;

const ContentWrapper = styled(Flex).attrs({
  direction: "column",
  align: { mobileAndAbove: "flex-start", tabletAndAbove: "center" },
})`
  background-color: ${Decorative.tint.orange};
`;

const StyledContactUsButton = styled(ContactUsButton).attrs({
  iconDisabled: true,
})`
  width: fit-content;
`;
